import { render, staticRenderFns } from "./MyQna.vue?vue&type=template&id=1b911260&"
import script from "./MyQna.vue?vue&type=script&lang=ts&"
export * from "./MyQna.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports